import React from 'react'

interface ChevronRightIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
  color = '#000',
  gradient = false,
  width = 24,
  height = 24,
  alt = 'Chevron right icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillOpacity='0.87'
        fillRule='evenodd'
        d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default ChevronRightIcon
